// ** Custom Icon Import
import Icon from '../../icon'

const UserIcon = ({ icon, ...rest }) => {
  return <Icon icon={icon} {...rest} />
}

export default UserIcon
